import { render } from "./ConfigComponents.vue?vue&type=template&id=2b045dcf&scoped=true&ts=true"
import script from "./ConfigComponents.vue?vue&type=script&lang=ts"
export * from "./ConfigComponents.vue?vue&type=script&lang=ts"

import "./ConfigComponents.vue?vue&type=style&index=0&id=2b045dcf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b045dcf"]])

export default __exports__